import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants/constants';
import { queryKeys, requestCCApi } from 'src/utils';

import { narrativeGenerators } from '../../userActions/helper';

export const useDeleteDyDisplay = () => {
  return useMutation({
    mutationFn: deleteDyDisplay,
    onSuccess: async () => {
      await queryClient.invalidateQueries(queryKeys.products.invalidateAll());
      await queryClient.invalidateQueries(
        queryKeys.productVariations.invalidateAll(),
      );
    },
  });
};

const deleteDyDisplay = async (payload: {
  templateId: number;
  templateName: string;
  variationName: string;
}) => {
  const narrative = (
    narrativeGenerators[COLLECTIONS.VARIATION_TEMPLATES][
      USER_ACTIONS.DELETE
    ] as (variationName: string) => string
  )(payload.variationName);

  const response = await requestCCApi(
    {
      url: '/transaction',
      method: 'POST',
      data: {
        data: [
          {
            resource: COLLECTIONS.VARIATION_TEMPLATES,
            method: 'DELETE',
            id: String(payload.templateId),
            data: { narrative },
          },
        ],
      },
    },
    true,
  );

  return response;
};
